import React from 'react'

const Divider: React.FC = () => {
  return (
    <div className="my-8 h-0.5 bg-gray-200" />
  )
}

export default Divider